// id 印度尼西亚
export default {
    CustomSelect: {
        '请选择': 'Pilih',
    },
    TopNav: {
        '创作者': 'Kreator',
        '游客': 'Tamu',
        '请登录后体验完整功能': 'Silakan login untuk fungsi lengkap',
        '登录': 'Masuk',
        '免费试用': 'Coba Gratis',
        '退出登录': 'Keluar',
        '个人中心': 'Akun Saya',
        '我的视频': 'Video Saya',
        '额度管理': 'Manajemen Kuota',
        '首页': 'Beranda',
        'AI创作': 'Buat AI',
        '多参考': 'Multi-Referensi',
        '文本视频': 'Teks ke Video',
        '图片视频': 'Gambar ke Video',
        '文生图': 'Teks ke Gambar',
        '图生图': 'Gambar ke Gambar',
        '会员中心': 'Pusat Keanggotaan',
        '概览': 'Ringkasan',
        '我的创作': 'Kreasiku',
        '账单管理': 'Manajemen Tagihan',
        '生成任务': 'Tugas Generasi',
        '价格': 'Harga',
        '新闻资讯': 'Berita',
        '确定要退出登录吗？': 'Yakin ingin keluar?',
        '提示': 'Tips',
        '确定': 'OK',
        '取消': 'Batal',
        '退出成功': 'Berhasil keluar',
        '视频展示': 'Tayangan video'
    },
    AiLayout: {
        'AI创作中心': 'Pusat Kreativitas AI',
        '视频生成': 'Hasilkan Video',
        '图片生成': 'Hasilkan Gambar',
        '我的作品': 'Karyaku',
        '我的创作': 'Kreasiku',
        '今日剩余额度': 'Sisa Kuota Hari Ini',
        '多参考': 'Multi-Referensi',
        '文本视频': 'Teks ke Video',
        '图片视频': 'Gambar ke Video',
        '文生图': 'Teks ke Gambar',
        '图生图': 'Gambar ke Gambar',
    },
    HomeLayout: {
        '下一代AI视频生成平台': 'Platform Generasi Video AI Generasi Berikutnya, wujudkan ide secara instan',
        '产品': 'Produk',
        'AI视频': 'Video AI',
        '价格方案': 'Paket Harga',
        '新闻资讯': 'Berita',
        '支持': 'Dukungan',
        '帮助中心': 'Pusat Bantuan',
        'API文档': 'Dokumen API',
        '常见问题': 'FAQ',
        '法律': 'Hukum',
        '服务条款': 'Ketentuan Layanan',
        '隐私政策': 'Kebijakan Privasi',
        '使用协议': 'Perjanjian Penggunaan',
        '版权所有': 'Hak Cipta Dilindungi',
        '客服邮箱': 'Email Dukungan',
        '复制邮箱': 'Salin Email',
        '开发中': 'Sedang dikembangkan, nantikan!',
        '链接已复制到剪贴板': 'Tautan disalin ke papan klip',
    },
    MyLayout: {
        '创作者': 'Kreator',
        '退出登录': 'Keluar',
        '概览': 'Ringkasan',
        '我的创作': 'Kreasiku',
        '会员中心': 'Pusat Keanggotaan',
        '额度管理': 'Manajemen Kuota',
        '账单管理': 'Manajemen Tagihan',
        '生成任务': 'Tugas Generasi',
        '确定要退出登录吗？': 'Yakin ingin keluar?',
        '提示': 'Tips',
        '确定': 'OK',
        '取消': 'Batal',
        '退出成功': 'Berhasil keluar'
    },
    Image: {
        "文本生成图片": "Teks ke Gambar",
        "图片生成图片": "Gambar ke Gambar",
        "用文字描述": "Jelaskan dengan kata-kata gambar yang Anda inginkan",
        "上传图片素材": "Unggah materi gambar, dukung generasi multi-gambar",
        "图片描述": "Deskripsi Gambar",
        "描述您想要的图片": "Jelaskan secara detail konten gambar yang ingin Anda hasilkan, dukung bahasa Indonesia atau Inggris...",
        "提示描述越详细效果越好": "Tips: Semakin detail deskripsinya, semakin baik hasil generasinya",
        "图片素材": "Materi Gambar",
        "预览图片": "Pratinjau",
        "上传图片": "Unggah Gambar",
        "支持格式JPGPNG": "Mendukung format JPG, PNG",
        "最多": "Maksimal",
        "张图片": "gambar",
        "超过大小限制": "Melebihi batas 10MB",
        "不是图片文件": "Bukan file gambar yang valid",
        "最多上传": "Maksimal unggah",
        "请先上传图片": "Silakan unggah materi gambar terlebih dahulu",
        "请选择要生成的图片": "Silakan pilih gambar yang akan dihasilkan",
        "生成结果": "Hasil Generasi",
        "重新生成成功": "Berhasil hasilkan ulang",
        "模型": "Model AI",
        "请选择模型": "Silakan pilih model generasi",
        "分辨率": "Resolusi Keluaran",
        "请选择分辨率": "Silakan pilih resolusi",
        "图片比例": "Rasio Gambar",
        "补充描述": "Deskripsi Tambahan (opsional)",
        "补充描述提示": "Opsional, jelaskan efek atau gaya tambahan yang Anda inginkan pada gambar",
        "开始绘制": "Mulai Buat",
        "开始生成": "Mulai Hasilkan",
        "生成中": "Sedang menghasilkan, harap tunggu...",
        "生成成功": "Berhasil",
        "图片生成成功": "Gambar berhasil dihasilkan!",
        "作品已保存到我的作品": "Karya telah disimpan ke 'Karyaku'",
        "继续创作": "Lanjutkan Buat",
        "查看作品": "Lihat Karya",
        "请输入图片描述": "Masukkan deskripsi gambar"
    },
    MyCreation: {
        '我的创作': 'Kreasiku',
        '查看和管理您的所有作品': 'Lihat dan kelola semua karya Anda',
        '预览': 'Pratinjau',
        '下载': 'Unduh',
        '编辑': 'Edit',
        '分享': 'Bagikan',
        '删除': 'Hapus',
        '暂无作品': 'Tidak ada karya',
        '去创作': 'Buat',
        '确定删除': 'Yakin hapus',
        '确定要删除作品': 'Yakin ingin menghapus karya',
        '吗？': '?',
        '此操作不可恢复': 'Tindakan ini tidak dapat dibatalkan, harap berhati-hati!',
        '取消': 'Batal',
        '分享作品': 'Bagikan Karya',
        '复制链接': 'Salin Tautan',
        '全部': 'Semua',
        '视频': 'Video',
        '图片': 'Gambar',
        '正在下载:': 'Mengunduh: ',
        '链接已复制到剪贴板': 'Tautan disalin ke papan klip',
        '删除成功': 'Berhasil dihapus'
    },
    Video: {
        "文本生成视频": "Teks ke Video",
        "图片生成视频": "Gambar ke Video",
        "智能视频生成": "Hasilkan Video Cerdas",
        "输入文字描述": "Masukkan deskripsi teks",
        "上传1-9张图片": "Unggah 1-9 gambar",
        "上传图片视频音频": "Unggah gambar/video/audio",
        "视频描述": "Deskripsi Video",
        "描述您想要的视频场景": "Jelaskan adegan video yang Anda inginkan",
        "提示": "Tips",
        "图片素材": "Materi Gambar",
        "最多上传": "Maksimal unggah",
        "张": "gambar",
        "预览": "Pratinjau",
        "上传图片": "Unggah Gambar",
        "支持格式": "Mendukung format JPG, PNG, maksimal 10MB per file, maksimal",
        "AI": "AI menggabungkan secara cerdas, akan menghasilkan efek transisi yang mulus",
        "动态描述": "Deskripsi Gerakan",
        "描述您希望图片如何动起来": "Jelaskan bagaimana Anda ingin gambar bergerak",
        "个": "item",
        "上传视频": "Unggah Video",
        "上传音频": "Unggah Audio",
        "描述您希望视频呈现的效果": "Jelaskan efek yang Anda inginkan pada video",
        "模型": "Model",
        "请选择模型": "Silakan pilih model",
        "分辨率": "Resolusi",
        "请选择分辨率": "Silakan pilih resolusi",
        "宽高比": "Rasio Aspek",
        "视频时长": "Durasi Video",
        "生成音频": "Hasilkan Audio",
        "开启音效": "Aktifkan Efek Suara",
        "静音模式": "Mode Bisu",
        "音频提示": "Tips: Audio yang diunggah akan digunakan sebagai musik latar, AI akan menghasilkan musik secara otomatis jika tidak ada audio yang diunggah",
        "开始生成": "Mulai Hasilkan",
        "积分": "Kredit",
        "生成中": "Sedang menghasilkan",
        "生成成功": "Berhasil",
        "视频生成成功！": "Video berhasil dihasilkan!",
        "作品已保存到": "Karya telah disimpan ke 'Karyaku'",
        "继续创作": "Lanjutkan Buat",
        "查看作品": "Lihat Karya",
        "视频预览": "Pratinjau Video",
        "关闭": "Tutup",
        "下载视频": "Unduh Video",
        "您的浏览器不支持视频播放": "Browser Anda tidak mendukung pemutaran video",
        "生成进度": "Progres Generasi",
        "描述": "Deskripsi",
        "时长": "Durasi",
        "秒": "detik",
        "视频素材": "Materi Video",
        "音频素材": "Materi Audio",
        "双图融合模式": "Mode Fusion Dua Gambar",
        "开始下载视频": "Mulai unduh video",
        "请输入视频描述": "Masukkan deskripsi video",
        "请至少上传一张图片": "Silakan unggah setidaknya satu gambar",
        "请至少上传一张图片或一个视频": "Silakan unggah setidaknya satu gambar atau satu video",
        "最多只能上传": "Maksimal unggah",
        "超过": "Melebihi",
        "限制": "batas",
        "不是图片文件": "Bukan file gambar yang valid",
        "不是视频文件": "Bukan file video yang valid",
        "不是音频文件": "Bukan file audio yang valid"
    },
    Forgot: {
        "找回密码": "Pulihkan Kata Sandi",
        "请输入您的邮箱，我们将发送验证码": "Masukkan email Anda, kami akan mengirimkan kode verifikasi",
        "密码重置成功，请使用新密码登录": "Kata sandi berhasil direset, silakan login dengan kata sandi baru",
        "密码重置成功": "Kata sandi berhasil direset",
        "您的密码已成功重置，请使用新密码登录": "Kata sandi Anda berhasil direset, silakan login dengan kata sandi baru Anda",
        "立即登录": "Login Sekarang",
        "邮箱": "Email",
        "请输入注册邮箱": "Masukkan email terdaftar",
        "发送验证码": "Kirim Kode",
        "请输入验证码": "Masukkan kode verifikasi",
        "验证码": "Kode Verifikasi",
        "新密码": "Kata Sandi Baru",
        "设置新密码": "Atur Kata Sandi Baru",
        "确认新密码": "Konfirmasi Kata Sandi Baru",
        "再次输入新密码": "Masukkan kata sandi baru lagi",
        "重置密码": "Reset Kata Sandi",
        "返回登录": "Kembali ke Login",
        "验证中": "Memverifikasi",
        "重置中": "Mereset",
        "弱": "Lemah",
        "中": "Sedang",
        "强": "Kuat",
        "请输入邮箱地址": "Masukkan alamat email",
        "请输入正确的邮箱格式": "Masukkan format email yang benar",
        "验证码应为6位数字": "Kode verifikasi harus 6 digit",
        "请输入新密码": "Masukkan kata sandi baru",
        "密码至少需要6位": "Kata sandi minimal 6 karakter",
        "请再次输入新密码": "Masukkan kata sandi baru lagi",
        "两次输入的密码不一致": "Kata sandi yang dimasukkan tidak cocok",
        "验证码已发送": "Kode verifikasi telah dikirim"
    },
    Login: {
        "下一代AI视频生成平台": "Platform Generasi Video AI Generasi Berikutnya",
        "一键生成": "Hasilkan Satu Klik",
        "支持4K超高清输出": "Dukungan keluaran 4K Ultra HD",
        "多种风格模板任选": "Pilih dari berbagai template gaya",
        "商用授权无忧使用": "Lisensi komersial, gunakan tanpa khawatir",
        "欢迎回来": "Selamat datang kembali",
        "登录您的账号继续创作": "Login ke akun Anda untuk melanjutkan membuat",
        "邮箱": "Email",
        "请输入邮箱地址": "Masukkan alamat email",
        "密码": "Kata Sandi",
        "请输入您的密码": "Masukkan kata sandi Anda",
        "记住我": "Ingat saya",
        "忘记密码？": "Lupa kata sandi?",
        "登录": "Masuk",
        "登录中": "Sedang login",
        "还没有账号？": "Belum punya akun?",
        "立即注册": "Daftar Sekarang",
        "请输入正确的邮箱格式": "Masukkan format email yang benar",
        "请输入密码": "Masukkan kata sandi",
        "密码至少需要6位": "Kata sandi minimal 6 karakter",
        "密码不能超过20位": "Kata sandi tidak boleh melebihi 20 karakter",
        "登录成功": "Berhasil login"
    },
    Register: {
        "创建账号": "Buat Akun",
        "开始您的AI视频创作之旅": "Mulailah perjalanan kreativitas video AI Anda",
        "姓名": "Nama",
        "请输入您的姓名": "Masukkan nama Anda",
        "邮箱": "Email",
        "请输入邮箱地址": "Masukkan alamat email",
        "获取验证码": "Dapatkan Kode",
        "验证码": "Kode Verifikasi",
        "请输入验证码": "Masukkan kode verifikasi",
        "密码": "Kata Sandi",
        "设置密码": "Atur Kata Sandi",
        "确认密码": "Konfirmasi Kata Sandi",
        "再次输入密码": "Masukkan kata sandi lagi",
        "我已阅读并同意": "Saya telah membaca dan menyetujui",
        "服务条款": "Ketentuan Layanan",
        "和": "dan",
        "隐私政策": "Kebijakan Privasi",
        "注册中": "Sedang mendaftar",
        "已有账号？": "Sudah punya akun?",
        "立即登录": "Login Sekarang",
        "弱": "Lemah",
        "中": "Sedang",
        "强": "Kuat",
        "请输入姓名": "Masukkan nama",
        "姓名至少需要2个字符": "Nama minimal 2 karakter",
        "姓名不能超过20个字符": "Nama tidak boleh melebihi 20 karakter",
        "请输入正确的邮箱格式": "Masukkan format email yang benar",
        "验证码应为6位数字": "Kode verifikasi harus 6 digit",
        "请输入密码": "Masukkan kata sandi",
        "密码至少需要6位": "Kata sandi minimal 6 karakter",
        "密码不能超过20位": "Kata sandi tidak boleh melebihi 20 karakter",
        "请再次输入密码": "Masukkan kata sandi lagi",
        "两次输入的密码不一致": "Kata sandi yang dimasukkan tidak cocok",
        "验证码已发送": "Kode verifikasi telah dikirim",
        "注册成功": "Berhasil mendaftar"
    },
    Faq: {
        '常见问题': 'Pertanyaan Umum',
        '您在使用过程中遇到的问题': 'Masalah yang Anda temui selama penggunaan, temukan jawabannya di sini',
        '搜索您的问题': 'Cari pertanyaan Anda...',
        '没有找到相关的问题': 'Tidak menemukan pertanyaan terkait',
        '查看全部问题': 'Lihat semua pertanyaan',
        '没有找到您想要的答案？': 'Tidak menemukan jawaban yang Anda cari?',
        '我们的客服团队随时为您提供帮助': 'Tim dukungan kami siap membantu Anda kapan saja',
        '复制客服邮箱': 'Salin email dukungan',
        '链接已复制到剪贴板': 'Tautan disalin ke papan klip'
    },
    Home: {
        '立即订阅': 'Langganan sekarang',
        'AI视频生成新时代': 'Era Baru Generasi Video AI',
        '用文字创造': 'Buat dengan Kata-kata',
        '无限视频': 'Video Tanpa Batas',
        '让每个人都能成为视频创作者': 'Memberdayakan setiap orang untuk menjadi kreator video. Cukup masukkan deskripsi teks untuk mendapatkan video AI berkualitas tinggi dan unik.',
        '免费开始': 'Mulai Gratis',
        '观看演示': 'Tonton Demo',
        'AI生成': 'Hasilkan AI',
        'AI视频': 'Video AI',
        '三步轻松生成专业视频': 'Tiga langkah mudah hasilkan video profesional',
        '输入提示词': 'Masukkan perintah',
        '用文字描述您想要的视频内容': 'Jelaskan konten video yang Anda inginkan dengan kata-kata, semakin detail semakin baik',
        '智能生成': 'Generasi Cerdas',
        'AI模型自动理解并创作': 'Model AI memahami dan membuat secara otomatis, rendering selesai dalam beberapa menit',
        '下载作品': 'Unduh Karya',
        '高清视频生成完成': 'Generasi video HD selesai, siap diunduh dan digunakan segera',
        'AI视频生成': 'Generasi Video AI',
        '精彩视频': 'Masukkan deskripsi teks, AI akan menghasilkan video menarik untuk Anda',
        '描述您想要的视频场景': 'Jelaskan adegan video yang Anda inginkan, misalnya: Seekor kucing bermain di bawah pohon sakura, sinar matahari menembus kelopak bunga...',
        '生成中': 'Sedang menghasilkan...',
        '生成视频': 'Hasilkan Video',
        'AI图片': 'Gambar AI',
        '精美图片': 'Masukkan deskripsi teks, AI akan menghasilkan gambar menarik untuk Anda',
        '描述您想要的图片场景': 'Jelaskan adegan gambar yang Anda inginkan, misalnya: Langit-langit kota masa depan, lampu neon berkedip, gaya cyberpunk...',
        '生成图片': 'Hasilkan Gambar',
        '强大功能': 'Fitur Hebat',
        '让视频创作变得简单有趣': 'Membuat pembuatan video menjadi sederhana dan menyenangkan',
        '案例展示': 'Contoh',
        '来看看用户使用': 'Lihat karya luar biasa yang dibuat oleh',
        '创作的精彩作品': 'pengguna',
        '新闻资讯': 'Berita',
        '了解': 'Ikuti',
        '的最新动态和产品更新': 'berita terbaru dan pembaruan produk',
        '查看更多': 'Lihat Lainnya',
        '热门': 'Populer',
        '最新': 'Terbaru',
        '阅读更多': 'Baca Selengkapnya',
        '选择适合您的方案': 'Pilih paket yang sesuai untuk Anda',
        '灵活的定价': 'Harga fleksibel, memenuhi berbagai kebutuhan',
        '视频预览': 'Pratinjau Video',
        '生成成功': 'Berhasil',
        '作品已保存到': 'Karya telah disimpan ke "Kreasiku"',
        '继续创作': 'Lanjutkan Buat',
        '查看作品': 'Lihat Karya',
        '请输入视频描述': 'Masukkan deskripsi video',
        '视频生成成功！': 'Video berhasil dihasilkan!',
        '请输入图片描述': 'Masukkan deskripsi gambar',
        '图片生成成功！': 'Gambar berhasil dihasilkan!',
    },
    News: {
        '新闻资讯': 'Berita',
        '了解': 'Ikuti',
        '的最新动态和产品更新': 'berita terbaru dan pembaruan produk',
        '精选': 'Pilihan',
        '阅读': 'Baca',
        '点赞': 'Suka',
        '热门': 'Populer',
        '最新': 'Terbaru',
        '阅读更多': 'Baca Selengkapnya',
        '加载中': 'Memuat...',
        '暂无新闻': 'Tidak ada berita',
        '清除筛选': 'Hapus Filter',
        '加载新闻失败': 'Gagal memuat berita, silakan coba lagi nanti',
    },
    Price: {
        '选择适合您的方案': 'Pilih paket yang sesuai untuk Anda',
        '灵活的定价': 'Harga fleksibel, memenuhi berbagai kebutuhan',
        '包月': 'Bulanan',
        '包年': 'Tahunan',
        '购买积分': 'Beli Kredit',
        '只需要几个视频': 'Hanya perlu beberapa video? Tanpa langganan, langsung beli paket kredit',
        '产品大全': 'Katalog Produk',
        '了解': 'Ikuti',
        '全系列产品的详细信息和支付方式': 'informasi detail dan metode pembayaran untuk seluruh rangkaian produk'
    },
    Billing: {
        '账单管理': 'Manajemen Tagihan',
        '账户余额': 'Saldo Akun',
        '本月支出': 'Pengeluaran Bulan Ini',
        '订单数量': 'Jumlah Pesanan',
        '账单列表': 'Daftar Tagihan',
        '请选择类型': 'Pilih jenis',
        '请选择时间范围': 'Pilih rentang waktu',
        '订单号': 'Nomor Pesanan',
        '类型': 'Jenis',
        '金额': 'Jumlah',
        '状态': 'Status',
        '时间': 'Waktu',
        '操作': 'Tindakan',
        '查看详情': 'Lihat Detail',
        '下载发票': 'Unduh Faktur',
        '暂无作品': 'Tidak ada karya',
        '去创作': 'Buat',
        '支付方式': 'Metode Pembayaran',
        '添加支付方式': 'Tambah Metode',
        '默认': 'Default',
        '设为默认': 'Jadikan Default',
        '编辑': 'Edit',
        '删除': 'Hapus',
        '账单详情': 'Detail Tagihan',
        '交易流水号': 'Nomor Transaksi',
        '关闭': 'Tutup',
        '账号': 'Akun/Nomor Kartu',
        '请输入账号或卡号': 'Masukkan nomor akun atau kartu',
        '姓名': 'Nama',
        '请输入持卡人姓名': 'Masukkan nama pemegang kartu',
        '有效期': 'Berlaku Hingga',
        '请输入CVV码': 'Masukkan kode CVV',
        '取消': 'Batal',
        '确认添加': 'Konfirmasi Tambah',
        '确认修改': 'Konfirmasi Ubah',
        '确认删除': 'Konfirmasi Hapus',
        '编辑支付方式': 'Edit Metode Pembayaran',
        '确定要删除支付方式': 'Yakin ingin menghapus metode pembayaran',
        '删除后不可恢复': 'Penghapusan tidak dapat dibatalkan, harap berhati-hati!',
        '请输入账号': 'Masukkan nomor akun/kartu',
        '添加成功': 'Berhasil ditambahkan',
        '修改成功': 'Berhasil diubah',
        '已设为默认支付方式': 'Telah ditetapkan sebagai metode pembayaran default',
        '删除成功': 'Berhasil dihapus',
    },
    Credit: {
        '额度管理': 'Manajemen Kuota',
        '当前可用额度': 'Kuota Tersedia Saat Ini',
        '升级会员': 'Tingkatkan Keanggotaan',
        '本月已用': 'Terpakai Bulan Ini',
        '视频生成': 'Hasilkan Video',
        'AI图片': 'Gambar AI',
        '其他': 'Lainnya',
        '购买额度包': 'Beli Paket Kuota',
        '最受欢迎': 'Terpopuler',
        '额度': 'Kuota',
        '立即购买': 'Beli Sekarang',
        '使用记录': 'Riwayat Penggunaan',
        '操作': 'Tindakan',
        '类型': 'Jenis',
        '额度变动': 'Perubahan Kuota',
        '时间': 'Waktu',
        '购买': 'Beli',
        '确认购买': 'Konfirmasi Pembelian',
        '金额': 'Jumlah: ',
        '获得': 'Mendapatkan',
        '取消': 'Batal',
        '今天': 'Hari Ini',
        '昨天': 'Kemarin',
    },
    Dashboard: {
        '欢迎回来': 'Selamat datang kembali,',
        '创建新视频': 'Buat Video Baru',
        '本月生成次数': 'Jumlah Generasi Bulan Ini',
        '剩余额度': 'Sisa Kuota',
        '总视频数': 'Total Video',
        '会员状态': 'Status Keanggotaan',
        '最近生成': 'Generasi Terbaru',
        '查看全部': 'Lihat Semua',
        '视频预览': 'Pratinjau Video',
        '视频生成中': 'Video sedang dihasilkan, harap tunggu untuk pratinjau',
    },
    Membership: {
        '会员中心': 'Pusat Keanggotaan',
        '当前方案': 'Paket Saat Ini',
        'Pro 会员': 'Pro',
        '专业创作者首选': 'Pilihan utama kreator profesional',
        '月': 'bulan',
        '会员有效期': 'Masa Berlaku Keanggotaan',
        '剩余天数': 'Sisa Hari',
        '续费会员': 'Perpanjang',
        '取消订阅': 'Batalkan Langganan',
        '本月使用情况': 'Penggunaan Bulan Ini',
        '视频生成': 'Hasilkan Video',
        '次': 'kali',
        '额度使用': 'Penggunaan Kuota',
        '快速生成': 'Generasi Cepat',
        '升级方案': 'Tingkatkan Paket',
        '联系销售': 'Hubungi Sales',
        '会员权益': 'Keuntungan Anggota',
        '续费后将延长会员有效期30天': 'Perpanjangan akan memperpanjang keanggotaan 30 hari',
        '取消': 'Batal',
        '确认续费': 'Konfirmasi Perpanjang',
        '取消后您将失去所有会员权益': 'Setelah pembatalan, Anda akan kehilangan semua keuntungan, sisa kuota akan tetap ada',
        '再想想': 'Pikirkan Lagi',
        '确认取消': 'Konfirmasi Batal',
        '姓名': 'Nama',
        '请输入您的姓名': 'Masukkan nama Anda',
        '请输入姓名': 'Masukkan nama',
        '公司': 'Perusahaan',
        '请输入公司名称': 'Masukkan nama perusahaan',
        '邮箱': 'Email',
        '请输入邮箱地址': 'Masukkan alamat email',
        '请输入邮箱': 'Masukkan email',
        '请输入正确的邮箱格式': 'Masukkan format email yang benar',
        '需求': 'Kebutuhan',
        '请描述您的需求': 'Jelaskan kebutuhan Anda',
        '提交': 'Kirim',
        '请填写需求': 'Silakan jelaskan kebutuhan',
        '续费成功': 'Berhasil memperpanjang! Masa keanggotaan telah diperpanjang',
        '已取消订阅': 'Berhasil membatalkan langganan, keanggotaan akan berakhir setelah masa berlaku habis',
        '提交成功': 'Berhasil dikirim, kami akan segera menghubungi Anda!',
    },
    Task: {
        '生成任务': 'Tugas Generasi',
        '新建任务': 'Tugas Baru',
        '进行中': 'Sedang Berjalan',
        '已完成': 'Selesai',
        '失败': 'Gagal',
        '队列中': 'Dalam Antrian',
        '活跃任务': 'Tugas Aktif',
        '刷新': 'Segarkan',
        '暂无活跃任务': 'Tidak ada tugas aktif',
        '预计剩余': 'Perkiraan Sisa',
        '暂停': 'Jeda',
        '继续': 'Lanjutkan',
        '取消': 'Batal',
        '最近完成': 'Baru Selesai',
        '查看全部': 'Lihat Semua',
        '暂无完成的任务': 'Tidak ada tugas yang selesai',
        '播放': 'Putar',
        '下载': 'Unduh',
        '分享': 'Bagikan',
        '确认取消': 'Konfirmasi Batal',
        '确定要取消任务吗': 'Yakin ingin membatalkan tugas?',
        '已消耗的额度将无法退还': 'Kuota yang telah terpakai tidak dapat dikembalikan',
        '返回': 'Kembali',
        '分享作品': 'Bagikan Karya',
        '复制链接': 'Salin Tautan',
        '任务列表已刷新': 'Daftar tugas telah disegarkan',
        '已暂停': 'Dijeda',
        '生成中': 'Sedang menghasilkan',
        '已恢复': 'Dilanjutkan',
        '任务已取消': 'Tugas dibatalkan',
        '链接已复制到剪贴板': 'Tautan disalin ke papan klip',
    },
    VideoShow: {
        '示例': 'Contoh',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'Koleksi klip pilihan dari perpustakaan demo kami. Klik kartu apa pun untuk mulai menghasilkan konten dengan gaya serupa.',
        '全部': 'Semua',
        '电影感': 'Sinematik',
        '角色': 'Karakter',
        '产品': 'Produk',
        '自然': 'Alam',
        '趣味': 'Menyenangkan',
        '加载中': 'Memuat',
        '暂无展示': 'Tidak ada demo tersedia',
        '视频预览': 'Pratinjau Video',
    },
    Request: {
        '加载中': 'Memuat...',
        '您已退出登录': 'Anda telah keluar, Anda dapat masuk kembali',
        '确认退出': 'Konfirmasi keluar',
        '重新登录': 'Masuk kembali',
        '错误': 'Kesalahan',
        '网络错误': 'Kesalahan Jaringan',
        '下载中': 'Mengunduh...'
    },
    Other: {
        '剩余额度': 'Sisa Kuota',
        '去登录': 'Masuk',
        '请登录后查看': 'Silakan masuk untuk melihat',
        '任务': 'Tugas',
        '可在「生成任务」中查看详情': ', detail dapat dilihat di "Tugas Generasi"',
        '查看详情': 'Lihat detail',
        '排队中': 'Dalam antrean',
        '运行中': 'Berjalan',
        '取消': 'Batalkan',
        '成功': 'Berhasil',
        '失败': 'Gagal',
        '超时': 'Waktu habis',
        '最后更新': 'Pembaruan terakhir:',
        '视频生成': 'Generasi Video',
        '活跃用户': 'Pengguna Aktif',
        '用户评分': 'Rating Pengguna',
        '万': 'ribu',
        '快速生成': 'Generasi Cepat',
        '先进的AI模型': 'Model AI canggih yang menghasilkan video berkualitas tinggi dalam hitungan menit',
        '多种风格': 'Beragam Gaya',
        '多种风格任您选择': 'Realistis, anime, artistik, dan banyak lagi pilihan gaya untuk Anda',
        '高清输出': 'Output HD',
        '支持4K超高清视频输出': 'Mendukung output video 4K Ultra HD, detail terlihat jelas',
        '商用授权': 'Lisensi Komersial',
        '生成的视频可用于商业用途': 'Video yang dihasilkan dapat digunakan untuk tujuan komersial, tanpa khawatir hak cipta',
        '原价': 'Harga Asli',
        '积分价格说明': 'Penjelasan Harga Kredit',
        '系列': 'Seri',
        '模型': 'Model',
        '分辨率': 'Resolusi',
        '积分': 'Kredit',
        '秒': 'detik',
        '秒示例': 'detik (contoh)',
        '图片模型': 'Model Gambar',
        '图片为': 'Gambar adalah',
        '系列产品': 'Produk seri, saat ini mendukung',
        '支持使用任意机型查看完整体验': ', mendukung penggunaan perangkat apa pun untuk pengalaman lengkap.',
        '计费方式': 'Metode Penagihan',
        '张': 'gambar',
        '按生成张数计费': 'Penagihan berdasarkan jumlah gambar yang dihasilkan',
        '普通用户': 'Pengguna Biasa',
        '无记录': 'Tidak ada catatan',
        '总支出': 'Total Pengeluaran',
        '月总使用': 'Total Penggunaan Bulanan',
        '月视频使用': 'Penggunaan Video Bulanan',
        '月图片使用': 'Penggunaan Gambar Bulanan',
        '生成成功': 'Generasi Berhasil',
        '视频总生成': 'Total Video Dihasilkan',
        '图片总生成': 'Total Gambar Dihasilkan',
        '生成中': 'Sedang menghasilkan, harap tunggu 1-3 menit',
        '来自我们演示库的一套精心挑选的剪辑片段': 'Kumpulan klip pilihan dari pustaka demo kami.',
        '最近7天': '7 hari terakhir',
        '最近30天': '30 hari terakhir',
        '本月': 'Bulan ini',
        '上月': 'Bulan lalu',
    }
}